
const IMAGE_FILE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif']

export function checkFileTypeImage (path) {
  const ext = path.split('.').pop()
  return IMAGE_FILE_EXTENSIONS.includes(ext)
}
